module.exports = __webpack_public_path__ + "static/reg-large7-44e30001ec1b51516bcb5f2c27c8f6eb.jpg";